import { Component, Input } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { LoyaltyProgram } from 'src/app/assabil-sales/models/entities/loyalty-program';
import { LoyaltyService } from 'src/app/assabil-sales/services/sales-loyalty-service';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';



@Component({
  selector: 'loyalty-partner-list',
  templateUrl: './loyalty-partner-list.component.html',
  styleUrls: ['./loyalty-partner-list.component.scss']
})
export class LoyaltyPartnerListComponent extends BasePage2<LoyaltyProgram> {

  
  @Input() periodActiveDay    : Date;
  @Input() loyaltyProgram     : string;
  @Input() geoAreaCode        : string;
  @Input() kpi                : string;

  // Filter fields
  // -------------------------------------------------------------------------------------
  increase           : boolean;
  decrease           : boolean;
  withPerfVoucher    : boolean;
  withAssetVoucher   : boolean;
  withReturnsVoucher : boolean;

  // -------------------------------------------------------------------------------------
  loyaltyPartners : any[] = [];
  // -------------------------------------------------------------------------------------

  title = "";
  // -------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected specificDanoneService    : SpecificDanoneService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "loyaltyPartner";
  }
//--------------------------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------
  ngOnInit() {
    //assigner periodActiveDay !!!!
    
    if (! this.embeded) return;
    this.loadData();
    this.title = "Détail des Clients " + this.loyaltyProgram;
  }
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
getRows(): LoyaltyProgram[] {
      return this.loyaltyPartners;
  }
//--------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------
loadData() {

  this.increase           = false;
  this.decrease           = false;
  this.withPerfVoucher    = false;
  this.withAssetVoucher   = false;
  this.withReturnsVoucher = false;
 
  // if (this.kpi === "ReturnsBonus")
  //   this.withReturnsVoucher = true;

  if (this.kpi === "AssetBonus")
    this.withAssetVoucher = true;
  
  if (this.kpi === "PerfBonus")
    this.withPerfVoucher = true;

  if (this.kpi === "Increase")
    this.increase = true;
    
  if (this.kpi === "Decrease")
    this.decrease = true;
  
   this.specificDanoneService.danoneLoyaltyPartnersGet(this.periodActiveDay, this.loyaltyProgram, this.geoAreaCode, 
    this.increase, this.decrease, this.withPerfVoucher, this.withAssetVoucher, this.withReturnsVoucher).then(result => {
      this.loyaltyPartners = result;
  })
}
//--------------------------------------------------------------------------------------------------------

}

